import { EXCLUSIVE_TYPE, ITagAttribute, EXCLUSIVE_TYPE_MAPPER } from '@interfaces/common.interface';
import Countdown from '@assets/images/tag-icons/countdown.svg';
import Flash from '@assets/images/tag-icons/flash.svg';
import { getDate } from '@helpers/date-time.helper';

export enum DealType {
	VOUCHER = 'VOUCHER',
	PROMO = 'PROMO_CODE',
}

export enum DealStatus {
	SCHEDULED = 'SCHEDULED',
	COUNTDOWN = 'COUNTDOWN',
	ONGOING = 'ONGOING',
	ENDED = 'ENDED',
	DEACTIVATED = 'DEACTIVATED',
}

export enum MerchantCategory {
	DINING = 'Dining',
	ACTIVITIES = 'Activities',
	RETAIL = 'Retail',
	WELLNESS = 'Wellness',
	SERVICES = 'Services',
}

export enum VOUCHER_EXPIRY {
	FIXED_EXPIRY_DATE = 'FIXED_EXPIRY_DATE',
	FIXED_MONTH_EXPIRY_DATE = 'FIXED_MONTH_EXPIRY_DATE',
	NONE = 'NONE',
}

export const DEAL_TAG_ATTRIBUTES = {
	VOUCHER: {
		text: 'Voucher',
		textColor: 'text-white',
		backgroundColor: 'bg-orange',
	} as ITagAttribute,
	FLASH: {
		text: 'Flash',
	},
	COUNTDOWN: (date: string) =>
		({
			textColor: 'text-white',
			icon: <Countdown />,
			backgroundColor: 'bg-blue-grey-darkest',
			bannerText: date && `Available to purchase from ${getDate(date)}`,
		} as ITagAttribute),
	ONGOING: (date: string) =>
		({
			bannerTextColor: 'text-blue-grey-darkest',
			bannerBg: 'bg-blue-grey-lighter',
			bannerText: date && `Available to purchase till ${getDate(date)}`,
		} as ITagAttribute),
	ONGOING_FLASH: ({ qty, date }: { qty: boolean; date?: string }) =>
		({
			textColor: 'text-blue-grey-darkest',
			icon: <Flash />,
			gradientColor: {
				start: 'from-[#F1AB3F]',
				end: 'to-[#F9ED32]',
			},
			bannerText:
				qty && date
					? `Available in limited quantity till ${getDate(date)}`
					: qty && !date
					? `Available in limited quantity`
					: date && `Available to purchase till ${getDate(date)}`,
		} as ITagAttribute),
	EXCLUSIVE: (type: EXCLUSIVE_TYPE) =>
		({
			textColor: 'text-white',
			gradientColor: {
				start: 'from-[#3023AE]',
				end: 'to-[#C86DD7]',
			},
			bannerText: EXCLUSIVE_TYPE_MAPPER[type],
			text: EXCLUSIVE_TYPE_MAPPER[type]
		} as ITagAttribute),
	ENDED: {
		textColor: 'text-white',
		backgroundColor: 'bg-grey',
		subTag: 'Sale Has Ended',
		bannerText: 'Sale Has Ended',
	} as ITagAttribute,
};
